/*
  Map description:

  key - uses as parameter in actions.models.modals[open|update|close]

  value - must equals the name of component in components/modals directory

 */

const modals = {
  Dialog: 'DialogModal',
  SomethingWentWrong: 'SomethingWentWrongModal',
  ServerError: 'ServerErrorModal',
  ChangesSaveSuccess: 'ChangesSaveSuccessModal',
  CardUpdateSuccess: 'CardUpdateSuccessModal',
  ProductDetails: 'ProductDetailsModal',
  SameFragranceError: 'SameFragranceErrorModal',
  RedeemConfirmation: 'RedeemConfirmationModal',
  RedeemSuccess: 'RedeemSuccessModal',
  QuizStart: 'QuizStartModal',
  PickDate: 'PickDateModal',
  MembershipInfo: 'MembershipInfoModal',
  FirstTimeVisit: 'FirstTimeVisitModal',

  // Queue
  HowQueueWorks: 'HowQueueWorksModal',
  QueueTutorial: 'QueueTutorialModal',
  EmptyQueueRecommendations: 'EmptyQueueRecommendationsModal',

  // New products
  newProducts: {
    Makeup: 'MakeupModal',
    Skincare: 'SkincareModal',
    SkincareWellness: 'SkincareWellnessModal',
    LipBalms: 'LipBalmsModal',
  },

  // Skip a Month
  SkipAMonth: 'SkipAMonthModal',
  SkipAMonthSuccess: 'SkipAMonthSuccessModal',

  UnskipSuccess: 'UnskipSuccessModal',

  // Change Frequency
  ChangeFrequency: 'ChangeFrequencyModal',
  FrequencyChangeSuccess: 'FrequencyChangeSuccessModal',

  // Update PayPal
  ErrorPayPal: 'ErrorPayPalModal',
  AlreadyUpdatedToPayPal: 'AlreadyUpdatedToPayPalModal',

  // Complete Subscription
  CompleteSubscription: 'CompleteSubscriptionModal',

  // Upgrade Subscription
  OldUpgradeSubscription: 'OldUpgradeSubscriptionModal',
  UpgradeSubscription: 'UpgradeSubscriptionModal',
  QueueUpgrade: 'QueueUpgradeModal',

  // Cancel Subscription
  cancelSubscription: {
    CancelSubscription: 'CancelSubscriptionModal',
    BeforeYouGo: 'BeforeYouGoModal',
    OneLastQuestion: 'OneLastQuestionModal',
    SubscriptionWasCancelled: 'SubscriptionWasCancelledModal',
    ProlongOffer: 'ProlongOfferModal',
    ProlongThankYou: 'ProlongThankYouModal',
    PauseSubscription: 'PauseSubscriptionModal',
    UnpauseRequired: 'UnpauseRequiredModal',
    UnsubscribeProducts: 'UnsubscribeProductsModal',
    Refund: 'RefundModal',
    RefundOnTheDayOfCharge: 'RefundOnTheDayOfCharge',
    ShippingAndBillingIssues: 'ShippingAndBillingIssuesModal',
    Feedback: 'FeedbackModal',
    // humble
    offerTest25off: 'OfferTest25offModal',
    offerTest25offSuccess: 'OfferTest25offSuccessModal',
    FeedbackFormFail: 'FeedbackErrorModal',
  },

  // Smart Search
  SubscriptionUndeliverable: 'SubscriptionUndeliverableModal',
  WeMissedYou: 'WeMissedYouModal',
  TryTwoThreeFragrances: 'TryTwoThreeFragrancesModal',

  // Prepaid Card
  prepaidCard: {
    PrepaidCardWithSubscriptionPlans: 'PrepaidCardWithSubscriptionPlansModal',
    PrepaidCardWithDiscount: 'PrepaidCardWithDiscountModal',
  },

  // Resubscribe
  resubscribe: {
    GetBackTogether: 'GetBackTogetherModal', // TODO remove this modal?
    ResubscribeWithDiscount: 'ResubscribeWithDiscountModal', // TODO remove this modal?
    SuccessfullyResubscribed: 'SuccessfullyResubscribedModal',
    ResubscribeSuccess: 'ResubscribeSuccessModal',
    ReactivateSubscription: 'ReactivateSubscriptionModal',
  },

  // Gift Sets
  GiftSetQuickView: 'GiftSetQuickViewModal',

  // Gift
  gifts: {
    SetGiftDate: 'SetGiftDateModal',
    ChooseGiftSize: 'ChooseGiftSizeModal',
    ChooseGiftCardSkin: 'ChooseGiftCardSkinModal',
    ChooseGiftCardValue: 'ChooseGiftCardValueModal',
    SetGiftRecipientInfo: 'SetGiftRecipientInfoModal',
    ChooseGiftCardDeliveryType: 'ChooseGiftCardDeliveryTypeModal',
    GiftRedeemed: 'GiftRedeemedModal',
  },

  // Review
  review: {
    ReviewItemList: 'ReviewItemListModal',
    ReviewComposer: 'ReviewComposerModal',
    ReviewEdit: 'ReviewEditModal',
    ReviewTags: 'ReviewTagsModal',
    LoginRequired: 'LoginRequiredModal',
    Recommendations: 'RecommendationsModal',
    IncubatorReviewEdit: 'IncubatorReviewEditModal',
  },

  // Pause Subscription
  pauseSubscription: {
    UnpauseSubscription: 'UnpauseSubscriptionModal',
    PauseSuccess: 'PauseSuccessModal',
    UnpauseSuccess: 'UnpauseSuccessModal',
    PauseOneMonthSuccess: 'PauseOneMonthSuccessModal',
  },

  // Invite
  ChooseFriendsToInvite: 'ChooseFriendsToInviteModal',

  // Register
  FacebookRegister: 'FacebookRegisterModal',
  RemindPassword: 'RemindPasswordModal',

  // Password
  ShortPassword: 'ShortPasswordModal',

  // ThankYou
  ThankYouQueue: 'ThankYouQueueModal',

  // Products
  RecommendationTag: 'RecommendationTagModal',
  NoteRecommendations: 'NoteRecommendationsModal',

  // Payment
  AddressValidation: 'AddressValidationModal',
  CustomAddressValidation: 'CustomAddressValidationModal',
  ErrorCVV: 'ErrorCVVModal',
  LeavePayment: 'LeavePaymentModal',

  // Downgrade
  PreparingDowngrade: 'PreparingDowngradeModal',
  AlreadyDowngrade: 'AlreadyDowngradeModal',

  // Limited Edition Products
  limitedEditionProducts: {
    NeedUpdateCard: 'NeedUpdateCardModal',
    NeedUpdateAddress: 'NeedUpdateAddressModal',
    NeedChangeFrequency: 'NeedChangeFrequencyModal',
    NeedResubscribe: 'NeedResubscribeModal',
    NeedSubscribe: 'NeedSubscribeModal',
    NeedUnpause: 'NeedUnpauseModal',
    NeedUnskip: 'NeedUnskipModal',
    OutOfStock: 'OutOfStockModal',
    OutOfStockNotify: 'OutOfStockNotifyModal',
    PutFirstInQueue: 'PutFirstInQueueModal',
  },

  premiumProducts: {
    WelcomeBack: 'WelcomeBackModal',
    AddedProduct: 'AddedProductModal',
    NeedCardUpdate: 'NeedCardUpdateModal',
    NeedPaymentData: 'NeedPaymentDataModal',
    NeedSubscription: 'NeedSubscriptionModal',
  },

  // Pick Page
  PickProducts: 'PickProductsModal',

  // Add To Queue
  addToQueue: {
    ProductAddedToQueue: 'ProductAddedToQueueModal',
    Offer: 'OfferModal',
  },

  SkincareProductDetails: 'SkincareProductDetailsModal',


  // Humble --------------------------------------------------------- /

  humble: {
    ServerError: 'HumbleServerErrorModal',
    FlashSaleExpired: 'FlashSaleExpiredModal',
    FeedbackFormSuccess: 'FeedbackSuccessModal',
    flashSale: 'FlashSaleModal',
  },
}


export default modals
